export default interface IConversionSettings {
  inputPath?: string;
  outputPath?: string;
  name: string;
}
